import setTransition from './setTransition.js';
import transitionStart from './transitionStart.js';
import transitionEnd from './transitionEnd.js';
export default {
  setTransition,
  transitionStart,
  transitionEnd
};


//////////////////
// WEBPACK FOOTER
// C:/laragon/www/agnes/web/app/themes/akyos-sage/node_modules/swiper/core/transition/index.js
// module id = 46
// module chunks = 0